export default "__VITE_ASSET__$o4XiyGE__"